var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    {
      staticClass: "transfer-confirm",
      class: { grey: _vm.opts.destAsset.endsWith("20D") }
    },
    [
      _vm.isPending
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "md-title" }, [
        _vm._v(_vm._s(_vm.i18n.withdraw_confirm()))
      ]),
      _vm._v(" "),
      _c("md-card-content", [
        _c(
          "div",
          { staticClass: "transfer-confirm__inner" },
          [
            _c("detail-row", {
              attrs: {
                prop: _vm.i18n.lbl_asset(),
                value: "" + _vm.formatedToken
              }
            }),
            _vm._v(" "),
            _c("detail-row", {
              attrs: {
                prop: _vm.i18n.lbl_amount(),
                value: _vm.i18n.c(_vm.opts.amount) + " " + _vm.formatedToken
              }
            }),
            _vm._v(" "),
            _vm.opts.externalDetails.withdrawalType === "xpay"
              ? [
                  _vm.opts.externalDetails.displayName
                    ? _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.withdraw_external({
                            asset: _vm.formatedToken
                          }),
                          value: "" + _vm.opts.externalDetails.displayName
                        }
                      })
                    : _vm._e()
                ]
              : [
                  _vm.opts.externalDetails.address
                    ? _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.withdraw_external({
                            asset: _vm.formatedToken
                          }),
                          value: "" + _vm.opts.externalDetails.address
                        }
                      })
                    : _vm._e()
                ],
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "md-size-100" },
              [
                _c(
                  "div",
                  { staticClass: "withdrawal-fees__label text_small" },
                  [_vm._v(_vm._s(_vm.i18n.lbl_sender_fees()))]
                ),
                _vm._v(" "),
                _c("detail-row", {
                  attrs: {
                    prop: _vm.i18n.lbl_fixed(),
                    value:
                      _vm.i18n.c(_vm.opts.fee.fixed) + " " + _vm.formatedToken
                  }
                }),
                _vm._v(" "),
                _c("detail-row", {
                  attrs: {
                    prop: _vm.i18n.lbl_percent(),
                    value:
                      _vm.i18n.c(_vm.opts.fee.percent) + " " + _vm.formatedToken
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.currentAssetLimit()
              ? _c(
                  "div",
                  { staticClass: "md-size-100" },
                  [
                    _c("h4", [
                      _c("b", [_vm._v(_vm._s(_vm.i18n.lbl_limits()))])
                    ]),
                    _vm._v(" "),
                    _vm.currentAssetLimit() &&
                    _vm.currentAssetLimit().dailyLimit
                      ? _c("div", { staticClass: "withdrawal-daily-limit" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.i18n.lim_withdrawal_daily_msg1({
                                  asset: _vm.formatedToken,
                                  limit: _vm.currentAssetLimit().dailyLimit
                                })
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.opts.externalDetails.address &&
                          _vm.opts.destAsset === "UAH"
                            ? _c("div", [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.i18n.lim_withdrawal_daily_msg2({
                                        asset: _vm.formatedToken,
                                        limit: 14900
                                      })
                                    )
                                  )
                                ])
                              ])
                            : _c("div", [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.i18n.lim_withdrawal_daily_msg2({
                                        asset: _vm.formatedToken,
                                        limit: _vm.currentAssetLimit()
                                          .dailyLimit
                                      })
                                    )
                                  )
                                ])
                              ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.i18n.lim_withdrawal_daily_msg3()))
                          ]),
                          _vm._v(" "),
                          _c("br")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentAssetLimit() &&
                    _vm.currentAssetLimit().weeklyLimit
                      ? _c("detail-row", {
                          attrs: {
                            prop: _vm.i18n.lim_weekly_left(),
                            value:
                              _vm.currentAssetLimit().weeklyLeft +
                              " " +
                              _vm.formatedToken
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentAssetLimit() &&
                    _vm.currentAssetLimit().monthlyLimit
                      ? _c("detail-row", {
                          attrs: {
                            prop: _vm.i18n.lim_monthly_left(),
                            value:
                              _vm.currentAssetLimit().monthlyLeft +
                              " " +
                              _vm.formatedToken
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentAssetLimit() &&
                    _vm.currentAssetLimit().annualLimit
                      ? _c("detail-row", {
                          attrs: {
                            prop: _vm.i18n.lim_annual_left(),
                            value:
                              _vm.currentAssetLimit().annualLeft +
                              " " +
                              _vm.formatedToken
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.limitList
                      ? _c(
                          "div",
                          {
                            staticClass: "withdraw__fees-container",
                            class: { loading: _vm.isFeesLoadPending }
                          },
                          [
                            _vm._l(_vm.limitList, function(item, key) {
                              return [
                                item.period === "day"
                                  ? _c("detail-row", {
                                      attrs: {
                                        prop: _vm.i18n.lim_daily_left(),
                                        value: _vm.roundCurrency(
                                          item.amount_limit - item.amount,
                                          _vm.opts.tokenCode
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                item.period === "operation" ||
                                item.period === "day"
                                  ? _c("div", { key: key }, [
                                      item.period === "operation"
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18n.lim_withdrawal_daily_msg1(
                                                  {
                                                    limit: item.amount_limit,
                                                    asset: _vm.formatedToken
                                                  }
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.period === "day"
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18n.lim_withdrawal_daily_msg2(
                                                  {
                                                    limit: item.amount_limit,
                                                    asset: _vm.formatedToken
                                                  }
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.i18n.lim_withdrawal_daily_msg3()
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap space-between" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { disabled: _vm.isPending },
              on: {
                click: function($event) {
                  return _vm.$emit(_vm.commonEvents.cancelClickEvent)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_cancel()) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "btn md-primary md-yellow",
              attrs: { disabled: _vm.isPending },
              on: {
                click: function($event) {
                  return _vm.$emit(
                    _vm.commonEvents.confirmClickEvent,
                    _vm.form.sourcePaysForDest
                  )
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_confirm()) + "\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2abd125e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abd125e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/withdrawal/make/Withdrawal.Confirm.vue
// module id = pP1f
// module chunks = 1